'use client'
import { CardText } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

const LiquidationDetailDataListError = () => {
  return (
    <div className="gap-sm flex flex-col">
      <CardText height="120px" text="An error occurred." />
    </div>
  )
}

export default memo(LiquidationDetailDataListError)
